export default "__VITE_ASSET__DFhpFVCJ__"